module Environments {
    module.controller("AgentGroupDetailsController", [
        "$scope",
        "$uibModal",
        "EnvironmentsService",
        "AgentsService",
        "notifications",
        function ($scope: IAgentGroupDetailsScope, $modal, environmentsService: IEnvironmentsService, agentsService: IAgentService, notifications) {
            var environmentModel = _.find($scope.environments, function (environment: IEnvironment) {
                return environment.name === $scope.$stateParams.environmentName;
            });

            //Bind input fileds to a clone, so unsaved changes get wiped on navigation
            $scope.environment = angular.copy(environmentModel);

            if (!$scope.environment) {
                $scope.$state.go("environments.detail", { environmentName: "Default" });
                return false;
            }

            var agentGroupName = $scope.$stateParams.agentGroupName;
            // If the agent group name is not specified, assume a new group is being created, also when the name is newAgentGroup (the route)
            if (typeof(agentGroupName) === "undefined" || agentGroupName === "" || agentGroupName === "newAgentGroup") {
                let group = environmentsService.createTemporaryAgentGroup();
                $scope.agentGroup = group;
                $scope.environment.agentGroups.push(group);
            } else {
                let group = _.find($scope.environment.agentGroups, function (agentGroup: IAgentGroup){
                                return agentGroup.name === $scope.$stateParams.agentGroupName;
                            });
                $scope.agentGroup = group;
            }

            if (!$scope.agentGroup) {
                $scope.$state.go("environments.detail", { environmentName: $scope.environment.name });
                return false;
            }

            $scope.isFarm = function () {
                return $scope.agentGroup.executionAgents.length > 1;
            };

            $scope.getAgentStatus = function (agent) {
                var status;
                if (agent.errorEventDuringLastDay) {
                    status = "status-failing";
                } else if (agent.lastStatus === FRENDS.Localizations.Unknown) {
                    status = "status-neutral";
                } else {
                    status = "status-passing";
                }
                return status;
            };

            $scope.showAgentDetails = function ($event, agent) {
                $scope.$state.go("environments.agentGroup.agent.detail", { agentName: agent.name });
            };
            $scope.preventEventBubbling = function ($event) {
                $event.stopPropagation();
            };

            $scope.saveAgentGroup = function() {
                environmentsService.saveAgentGroup($scope.agentGroup, $scope.environment).then((response) => {
                    if (response) {
                        var updatedEnv = response.data.updatedEnvironment;
                        var index = _.findIndex($scope.environments, function (e: IEnvironment) { return e.name === $scope.environment.name; });
                        $scope.environments[index] = updatedEnv;
                        $scope.environment = updatedEnv;
                        $scope.$state.go("environments.agentGroup", {agentGroupName: $scope.agentGroup.name});
                    }
                });
            }

            $scope.addNewAgent = function () {
                var becomingFarm = $scope.agentGroup.executionAgents.length > 0;
                var noConnectionString = $scope.agentGroup.connectionString === "";
                var validConnectionString = $scope.agentGroupEditorForm.connectionString.$valid;

                if (!validConnectionString) {
                    $scope.agentGroupEditorForm.connectionString.$setValidity("validConnectionString", false);
                } else if (becomingFarm && noConnectionString) {
                    //Attempting to add mulitple agents with an empty connection string. Show error.
                    $scope.agentGroupEditorForm.connectionString.$setValidity("required", false);
                } else {
                    //Good to navigate.
                    if ($scope.agentGroupEditorForm.$pristine) {
                        $scope.$state.go("environments.agentGroup.agent.new", { isGateway: false });
                    } else {
                        //Form has been changed -- save before navigating.
                        environmentsService.saveAgentGroup($scope.agentGroup, $scope.environment).then(function (response) {
                            if (response) {
                                var updatedEnv = response.data.updatedEnvironment;
                                var index = _.findIndex($scope.environments, function (e: IEnvironment) { return e.name === $scope.environment.name; });
                                $scope.environments[index] = updatedEnv;
                                $scope.environment = updatedEnv;
                                $scope.$state.go("environments.agentGroup.agent.new", { isGateway: false });
                            }
                        });
                    }
                }
            };

            $scope.addNewGatewayAgent = function () {
                if ($scope.agentGroupEditorForm.$pristine) {
                    $scope.$state.go("environments.agentGroup.agent.new", { isGateway: true });
                } else {
                    //Form has been changed -- save before navigating.
                    environmentsService.saveAgentGroup($scope.agentGroup, $scope.environment).then(function (response) {
                        if (response) {
                            var updatedEnv = response.data.updatedEnvironment;
                            var index = _.findIndex($scope.environments, function (e: IEnvironment) { return e.name === $scope.environment.name; });
                            $scope.environments[index] = updatedEnv;
                            $scope.environment = updatedEnv;
                            $scope.$state.go("environments.agentGroup.agent.new", { isGateway: true });
                        }
                    });
                }
            };

            $scope.downloadAgent = function ($event, agent) {
                $event.preventDefault();
                $event.stopPropagation();
                agentsService.download(agent.id);
            };

            $scope.editAgent = function ($event, agent) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.$state.go("environments.agentGroup.agent.edit", { agentName: agent.name });
            };

            $scope.removeAgent = function ($event, agent) {
                $event.preventDefault();
                $event.stopPropagation();

                var deleteConfirmation = $modal.open({
                    templateUrl: "DeleteConfirmationModalPartial",
                    size: "lg",
                    resolve: {
                        itemType: function () { return FRENDS.Localizations.Agent.toLowerCase() },
                        itemName: function () { return agent.name; }
                    },
                    controller: "DeleteConfirmationModalController as ctrl"
                });

                deleteConfirmation.result.then(function () {
                    agentsService.remove(agent).then(function (response) {
                        if (response) {
                            notifications.notify(response.data);
                            $scope.agentGroup.executionAgents = _.without($scope.agentGroup.executionAgents, agent);
                            $scope.agentGroup.gatewayAgents = _.without($scope.agentGroup.gatewayAgents, agent);
                            $scope.$state.reload();
                        }
                    });
                });
            };

            $scope.agentState = function () {
                return $scope.$state.current.name.indexOf("environments.agentGroup.agent") !== -1;
            };

            $scope.synchronizeAgents = function () {
                if ($scope.environment && $scope.agentGroup.executionAgents.length > 0) {
                    environmentsService.synchronizeAgents($scope.agentGroup).then(function (response) {
                        if (response) {
                            notifications.notify(response.data);
                        }
                    });
                } else {
                    notifications.notify(FRENDS.Localizations.Environment_SynchronizationNoAgentsFound);
                }
            };
        }
    ]);
    interface IAgentGroupDetailsScope extends ng.IScope {
        environments: IEnvironment[];
        environment: IEnvironment;
        agentGroup: IAgentGroup;
        $state: any;
        $stateParams: IAgentGroupStateParams;
        agentGroupEditorForm: IAgentGroupEditorForm;
        agentState: () => boolean;
        synchronizeAgents: () => any;
        removeAgent: ($event, agent) => any;
        editAgent: ($event, agent) => any;
        downloadAgent: ($event, agent) => any;
        addNewAgent: () => any;
        addNewGatewayAgent: () => any;
        showAgentDetails: ($event, agent) => any;
        getAgentStatus: (agent) => any;
        isFarm: () => boolean;
        saveAgentGroup: () => any;
        preventEventBubbling: ($event) => any;
    }

    interface IAgentGroupEditorForm extends ng.IFormController {
        connectionString: ng.INgModelController;
    }

    interface IAgentGroupStateParams {
        agentGroupName: string;
        environmentName: string;
        isNew: boolean;
    }
}

